import {
	AppState,
	ErrorMessagesViewModelKey,
	GamificationViewModelKey,
	WebsocketsViewModelKey,
} from '../models/AppState';

export const useErrorMessages = () => {
	return AppState[ErrorMessagesViewModelKey];
};

export const useGamification = () => {
	return AppState[GamificationViewModelKey];
};

export const useWebsockets = () => {
	return AppState[WebsocketsViewModelKey];
};
